import { render, staticRenderFns } from "./SectionItem.vue?vue&type=template&id=a33bb200&scoped=true"
import script from "./SectionItem.vue?vue&type=script&lang=js"
export * from "./SectionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33bb200",
  null
  
)

export default component.exports